import { Grid, Typography } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import '../../styles/agGridStyles.css';
import { PriorityItemDto } from '../../api';
import { ValueFormatterParams, CellClassParams } from 'ag-grid-community';
import { format, isWithinInterval, parseISO } from 'date-fns';
import enNZ from 'date-fns/esm/locale/en-NZ/index.js';
import { renderStatus } from '../../components/datagrid/ag-grid';
import { ICellRendererParams } from 'ag-grid-community';
interface ClientDisplayGridProps {
  client: string;
  priorities: (PriorityItemDto | null)[];
}

const dateCellRules = {
  'project-active': (params: CellClassParams) => {
    const today = new Date();
    const startDate = parseISO(params.data.startDate);
    const endDate = parseISO(params.data.endDate);
    return isWithinInterval(today, { start: startDate, end: endDate });
  },
};

function renderFullName(params: ICellRendererParams) {
  return params.data.employee.firstName + ' ' + params.data.employee.lastName;
}

function ClientDisplayGrid(props: ClientDisplayGridProps) {
  const { client, priorities } = props;

  function renderDateRange(params: ValueFormatterParams) {
    const startDate: Date = parseISO(params.data.startDate);
    const endDate: Date = parseISO(params.data.endDate);
    const formattedStartDate = format(startDate, 'dd/MM/yyyy', { locale: enNZ });
    const formattedEndDate = format(endDate, 'dd/MM/yyyy', { locale: enNZ });
    return `${formattedStartDate} - ${formattedEndDate}`;
  }

  function getColumnDefs() {
    return [
      {
        headerName: '',
        field: 'projectName',
        autoHeight: true,
        filter: true,
        wrapText: true,
        minWidth: 120,
      },
      {
        headerName: '',
        field: 'status',
        autoHeight: true,
        filter: true,
        minWidth: 100,
        wrapText: true,
        cellRenderer: renderStatus,
      },
      {
        headerName: '',
        field: 'employee.firstName',
        filter: true,
        autoHeight: true,
        wrapText: true,
        minWidth: 120,
        cellRenderer: renderFullName,
      },
      {
        headerName: '',
        field: 'description',
        filter: true,
        autoHeight: true,
        wrapText: true,
        minWidth: 400,
      },
      {
        headerName: '',
        field: 'startDate',
        filter: true,
        autoHeight: true,
        wrapText: true,
        minWidth: 225,
        valueFormatter: renderDateRange,
        cellClassRules: dateCellRules,
      },
    ];
  }

  return (
    <Grid
      container
      display="flex"
      direction="column"
      justifyContent={'center'}
      alignItems="center"
      spacing={1}
      paddingTop="3%"
    >
      <Grid item xs={12}>
        <div className="ag-theme-alpine" style={{ width: 1227 }}>
          <Typography variant="h4" marginBottom={0.5} paddingBottom="2%">{`${client}`}</Typography>
          <AgGridReact rowData={priorities} columnDefs={getColumnDefs()} domLayout="autoHeight" />
        </div>
      </Grid>
    </Grid>
  );
}

export default ClientDisplayGrid;
